import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    min-height: 100dvh;
    background-color: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
  }

  wow-wizard {
    display: block;
    width: 100%;
    min-height: 100vh; /* instead of 100dvh */
    height: 100%;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .scrollable-step {
    overflow-y: auto;
    height: 100dvh;
  }

  /* Email verification step styles */
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100dvh;
    width: 100%;
    background-color: var(--sds-color-background-neutral-subtle);
    color: var(--sds-color-text-default-inverse);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .content {
    width: 100%;
    max-width: 393px;
    background-color: var(--sds-color-background-neutral-strong);
    border-radius: var(--sds-size-border-radius-200);
    margin: 0 auto;
    padding: var(--sds-size-space-800);
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    box-sizing: border-box;
  }

  .verification-body {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .verification-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
    color: var(--sds-color-text-default-inverse);
  }

  .verification-text {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-default-secondary);
    margin: 0;
    white-space: pre-line;
    overflow-wrap: break-word;
  }

  /* Onboarding step styles */
  .onboarding-scroll-container {
    overflow-y: auto;
  }

  .onboarding-main-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .onboarding-header {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .onboarding-title-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .onboarding-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
  }

  .onboarding-subtitle {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-03);
    line-height: 1.4;
    color: var(--sds-color-text-default-secondary);
  }

  .onboarding-form-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .onboarding-sticky-button-container {
    position: sticky;
    bottom: 0;
    background: var(--sds-color-background-default-default);
    padding: var(--sds-size-space-800) 0;
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
  }

  .onboarding-submit-button {
    display: grid;
    width: 100%;
  }

  .social-links-content {
    display: grid;
    gap: var(--sds-size-space-300);
    overflow-y: auto;
  }

  .italic {
    font-style: italic;
  }

  .logo {
    margin-bottom: var(--sds-size-space-1200);
  }

  @media (min-width: 768px) {
    .verification-title {
      font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
    }

    .verification-text {
      font-size: var(--sds-typography-scale-03);
    }

    .social-links-content {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .onboarding-sticky-button-container {
      position: inherit;
      border-top: none;
      padding-top: 0;
    }

    .onboarding-submit-button {
      margin-top: var(--sds-size-space-800);
    }
  }
`;
